import React from 'react'
import { connect } from 'react-redux'
import ApplyTeam from './ApplyTeam'
import InvitePlayer from './InvitePlayer'
import InvitePlayerEmail from './InvitePlayerEmail'
import Notification from './Notification'
import LeaveHackathon from './LeaveHackathon'
import ComposeNotif from './ComposeNotif'
import DeleteTeam from './DeleteTeam'
import TeamsInfo from './TeamsInfo'
import EditAnswer from './EditAnswer'
import AnswerToQuestion from './AnswerToQuestion'
import AdminAnswerEdit from './AdminAnswerEdit'
import AddPoll from './AddPoll'
import ShowVotes from './ShowVotes'
import UniqueVotes from './UniqueVotes'

const styling = {
  position: 'fixed',
  background: '#ffffff6e',
  width: '100%',
  height: '100%',
  zIndex: '1',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const PopupSwitcher = (props) => (
  <div style={styling}>
    {props.popup.showApplyTeam && <ApplyTeam />}
    {props.popup.showInvitePlayer && <InvitePlayer />}
    {props.popup.showNotification && <Notification />}
    {props.popup.showEmailInvite && <InvitePlayerEmail />}
    {props.popup.showLeaveHackathon && <LeaveHackathon />}
    {props.popup.showSendNotif && <ComposeNotif />}
    {props.popup.showDeleteTeam && <DeleteTeam />}
    {props.popup.showTeamsInfo && <TeamsInfo />}
    {props.popup.showEditAnswer && <EditAnswer />}
    {props.popup.showAnswerToQuestion && <AnswerToQuestion />}
    {props.popup.showAdminAnswerEdit && <AdminAnswerEdit />}
    {props.popup.showAddPoll && <AddPoll />}
    {props.popup.showVotes && <ShowVotes />}
    {props.popup.showUniqueVotes && <UniqueVotes />}
  </div>
)

const mapStateToProps = (state) => {
  return {
    popup: state.popup
  }
}

export default connect(mapStateToProps)(PopupSwitcher)



// WEBPACK FOOTER //
// ./src/components/common/popups/PopupSwitcher.js